import { ColumnType } from "antd/es/table"
import { IProjectDataSQP } from "../types/projectDataSQP.types"
import useBaseColumns from "./UseBaseColumns"

const useProjectDataPrevWeekColumns = (): ColumnType<IProjectDataSQP>[] => {
  const columns = useBaseColumns()

  const columnsWithSearchTerm = [
    columns[0],
    {
      key: "spacer",
      dataIndex: "__spacer",
      width: 416,
      render: () => null,
    },
    ...columns.slice(1),
  ]

  return columnsWithSearchTerm
}

export default useProjectDataPrevWeekColumns
